import { Box } from '@healthinal/ui';
import { LungSpinner } from './LungSpinner.tsx';

export function SplashScreen() {
  return (
    <Box display="flex" alignItems="center" justifyContent="center" flex={1}>
      <LungSpinner size={'lg'} />
    </Box>
  );
}
